import React from "react";
import Select, { GroupBase, Props as SelectProps } from "react-select";

export type SearchSelectProps<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = SelectProps<Option, IsMulti, Group>;

const SearchSelect = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: SearchSelectProps<Option, IsMulti, Group>
): JSX.Element => <Select {...props} />;

export default SearchSelect;
